import {Component, Input} from '@angular/core';
import {BijbAccount} from '../../../models/bijb-account';
import { RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    standalone: true,
    imports: [MatMenuModule, FontAwesomeModule, NgIf, RouterLink]
})
export class MobileMenuComponent {
  @Input()
  public account: BijbAccount = null;
}
